import camelCase from '../util/camelCase';
import strToType from '../util/strToType';

export default class SlideComponent{
  constructor(initprops){

    // Bind methods to THIS
    this.init = this.init.bind(this);
    this.getSettings = this.getSettings.bind(this);
    this.setResponsive = this.setResponsive.bind(this);

    // Init Props
    this.props = initprops;

    this.possibleSettings = [
      'dots',
      'infinite',
      'slidesToShow',
      'slidesToScroll',
      'arrows',
      'autoplay',
      'autoplaySpeed',
      'responsive',
    ];

    this.extraSettings = {
      prevArrow: '<button type="button" class="slider-prev mdi mdi-chevron-left"></button>',
      nextArrow: '<button type="button" class="slider-next mdi mdi-chevron-right"></button>',
    };

    this.init();
  }

  init(){
    const els = document.querySelectorAll(this.props.el);

    if(els && els.length>0){
      for(let i=0; i<els.length; i++){
        const settings = Object.assign(this.extraSettings, this.getSettings(els[i]));
        jQuery(els[i]).slick(settings);
      }
    }
  }

  /**
   * Get settings based on el dataset
   * Convert setting keys to camelcase and check if they are valid for slick plugin
   */
  getSettings(el){

    const datasetObj = Object.assign({}, el.dataset);

    let finalObj = {};

    if (Object.keys(datasetObj).length>0){

      Object.keys(datasetObj)
      .filter(data =>
        this.possibleSettings.indexOf(data)!==-1
      )
      .map(key =>
        finalObj[camelCase(key)] = strToType(datasetObj[key])
      );
    }

    finalObj = Object.assign(finalObj, this.setResponsive(finalObj));

    return finalObj;
  }

  /**
   * Configure responsiveness
   */
  setResponsive(settings){
    if (typeof settings.slidesToShow !== 'undefined' && typeof settings.responsive !== 'undefined') {
      settings.responsive = [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: settings.slidesToShow,
          },
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: Math.ceil(settings.slidesToShow/2),
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: Math.ceil(settings.slidesToShow/4),
          },
        },
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 1,
          },
        },
      ];

      settings.mobileFirst = true;
      return settings;
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./scripts/components/slick.js